import FileBlock from './FileBlock-redux';

export default FileBlock;
